import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0438fe69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "modal-title space-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "의견 등록하기", -1))
const _hoisted_6 = { class: "wrapper_container" }
const _hoisted_7 = { class: "write_box" }
const _hoisted_8 = { class: "write_content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "board_info" }, "이 회사 어떤가요?"),
  /*#__PURE__*/_createElementVNode("div", { class: "gray regular" }, "회사의 최신 정보, 주주가 되기 전 궁금한 점, 투자 경험담, 주주로서의 생각 등 많은 분들의 의견이 좋은 정보가 됩니다.")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray regular" }, "-20자 이상 작성", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "write_byte" }
const _hoisted_13 = { class: "black" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray" }, "/400", -1))
const _hoisted_15 = { class: "info_message bold" }
const _hoisted_16 = { class: "info_message bold" }
const _hoisted_17 = { class: "space-between" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "star-rating" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "bold" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["value", "disabled", "onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info_message bold" }, " 작성 시 유의사항 "),
  /*#__PURE__*/_createElementVNode("ul", { class: "info_list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "로그인 회원만 작성 가능합니다."),
    /*#__PURE__*/_createElementVNode("li", null, "운영 정책을 위한반 경우, 통보 없이 의견이 삭제되고 지급된 포인트가 회수될 수 있습니다."),
    /*#__PURE__*/_createElementVNode("ul", { class: "sub_list" }, [
      /*#__PURE__*/_createElementVNode("li", null, "회사, 투자와 무관한 내용이나 동일 문자의 반복, 단순 문장 등 부적합한 내용이 있는 경우"),
      /*#__PURE__*/_createElementVNode("li", null, "동일한 의견을 지속적, 반복적으로 등록하는 경우"),
      /*#__PURE__*/_createElementVNode("li", null, "악의적 내용이나 욕설, 비방, 명예훼손을 포함한 내용이 있는 경우"),
      /*#__PURE__*/_createElementVNode("li", null, "오픈카톡방, 리딩방 등의 홍보 링크"),
      /*#__PURE__*/_createElementVNode("li", null, "게시판에 맞지 않는 내용이라고 운영자가 판단한 경우")
    ])
  ])
], -1))
const _hoisted_27 = { class: "save_btn" }
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':'취소'}); _ctx.dismiss()})
          }, "취소")
        ])
      ])
    ]),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("label", {
                id: "board_content",
                for: "input_content",
                class: "board_content",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args)))
              }, _hoisted_11, 512), [
                [_vShow, !_ctx.focusToggle]
              ]),
              _withDirectives(_createElementVNode("textarea", {
                id: "input_content",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.boardData.contents) = $event)),
                class: "input_content",
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleContent && _ctx.handleContent(...args))),
                onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
              }, null, 544), [
                [_vShow, _ctx.focusToggle],
                [_vModelText, _ctx.boardData.contents]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.boardData.contents.length), 1),
              _hoisted_14
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, " 닉네임 ", 512), [
            [_vShow, !_ctx.btnToggle]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_16, " 닉네임 변경중 ", 512), [
            [_vShow, _ctx.btnToggle]
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              id: "nickname_box",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.nickName) = $event)),
              type: "text",
              class: "nickname_box",
              placeholder: "닉네임을 만들어주세요!",
              disabled: !_ctx.btnToggle,
              onKeyup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nickNameTyping && _ctx.nickNameTyping(...args)))
            }, null, 40, _hoisted_18), [
              [_vModelText, _ctx.nickName]
            ]),
            _withDirectives(_createElementVNode("button", {
              class: "change_btn",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changingNickname && _ctx.changingNickname(...args)))
            }, " 변경하기 ", 512), [
              [_vShow, !_ctx.btnToggle]
            ]),
            _withDirectives(_createElementVNode("button", {
              class: "dup_check",
              disabled: !_ctx.nickName||_ctx.nodup,
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.checkNicknameDup && _ctx.checkNicknameDup(...args)))
            }, " 중복확인 ", 8, _hoisted_19), [
              [_vShow, _ctx.btnToggle]
            ]),
            _withDirectives(_createElementVNode("button", {
              class: "change_done",
              disabled: !_ctx.nodup,
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveNickname && _ctx.saveNickname(...args)))
            }, " 변경완료 ", 8, _hoisted_20), [
              [_vShow, _ctx.btnToggle]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: _normalizeClass(["star-comment", {green:(_ctx.boardData.point>0)}])
            }, [
              (_ctx.boardData.point>0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.boardData.point) + "점 · ", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.ratingComments[_ctx.boardData.point]), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_24, "성장성점수를 준다면?"))
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratings, (rating) => {
              return (_openBlock(), _createElementBlock("label", {
                key: rating,
                class: _normalizeClass(["star-rating__star", {'is-selected': ((_ctx.boardData.point >= rating) && _ctx.boardData.point != null), 'is-disabled': _ctx.disabled}])
              }, [
                _createElementVNode("input", {
                  class: "star-rating star-rating__checkbox",
                  type: "radio",
                  value: rating,
                  disabled: _ctx.disabled,
                  onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'점수입력', 'clickContent':rating}); _ctx.saveScore($event.target.value)}
                }, null, 8, _hoisted_25)
              ], 2))
            }), 128))
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              class: "block_btn",
              disabled: _ctx.btnToggle,
              onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'등록'}); _ctx.saveBoard()})
            }, " 등록 ", 8, _hoisted_28)
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}